import { render, staticRenderFns } from "./RoleEditDatalog.vue?vue&type=template&id=32f975ba&scoped=true&"
import script from "./RoleEditDatalog.vue?vue&type=script&lang=ts&"
export * from "./RoleEditDatalog.vue?vue&type=script&lang=ts&"
import style0 from "./RoleEditDatalog.vue?vue&type=style&index=0&id=32f975ba&prod&scoped=true&lang=css&"
import style1 from "./RoleEditDatalog.vue?vue&type=style&index=1&id=32f975ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f975ba",
  null
  
)

export default component.exports